/* istanbul ignore file -- @preserve */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Teams from 'pages/Teams';
import Management from 'pages/Management';

import { useCurrentUserContext } from 'utils/User';

import ROUTE_NAMES from 'setup/Routing/routeNames';

export default function TeamsRoute() {
  const { isSuperUser, isOemManager, isManager, managedSentinelTeams } =
    useCurrentUserContext();
  const location = useLocation();

  if (isSuperUser) {
    return <Teams />;
  }

  const managesMultipleTeams = managedSentinelTeams?.length > 1;
  if (isOemManager || isManager || managesMultipleTeams) {
    return <Management />;
  }

  return (
    <Navigate
      to={ROUTE_NAMES.access_denied}
      state={{ from: location }}
      replace
    />
  );
}
